require( 'inputmask/dist/jquery.inputmask.bundle' );

let input_masks = (function( $ ) {

	let _init = function() {
		let $twitter = $( 'input[id$="twitter_id"]' );

		if ( $twitter.length > 0 ) {
			$twitter.inputmask( {
				mask: '@[*{1,15}]',
				definitions: {
					'*': {
						validator: "[a-z0-9A-Z_]",
						casing: 'lower'
					}
				}
			} );
		}

		let $phone = $( 'input[id$="phone_number"]' );

		if ( $phone.length > 0 ) {
			_maybe_change_phone_mask( $phone );

			let $code = $phone.closest( '.crate-form' ).find( 'select[id$="phone_country"]' );

			$code.on( 'change', _code_changed );
		}
	};

	let _code_changed = function( e ) {
		let $phone = $( this ).closest( '.crate-form' ).find( 'input[id$="phone_number"]' );

		_maybe_change_phone_mask( $phone );
	};

	let _maybe_change_phone_mask = function( $phone ) {
		let $code = $phone.closest( '.crate-form' ).find( 'select[id$="phone_country"]' );

		if ( $code.length > 0 ) {
			let val = $code.val();

			$phone.inputmask( 'remove' );

			if ( val.indexOf( '+' ) >= 0 ) {
				val = val.split( '+' ).pop();

				$phone.inputmask( {
					mask: '+\\' + val + ' [*{+}]',
					definitions: {
						'*': {
							validator: "[0-9 ]",
							casing: 'lower'
						}
					}
				} );
			}
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = input_masks;